export const relationMapping = {
  "married": "Married",
  "partners": "Partners",
  "siblings": "Siblings",
  "parent": "Parent: Child",
  "parentInLaw": "Parent-In-Law: Child-In-Law",
  "grandparent": "Grandparent: Grandchild",
  "friends": "Friends",
  "coWorkers": "Co-Workers",
  "person": "Person: Related Party",
  "advisee": "Professional Advisor",
  "trustee": "Trustee: Trustee",
  "owner": "Organization: Owner",
  "officer": "Organization: Officer"
}

export default relationMapping;
